import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from './api/config';

function DeactivatedAccount() {
 
    const location = useLocation();
    const navigate = useNavigate();

    const [isUpdating, setIsUpdating] = useState(false);

// Safe access

const userid = location.state?.userid;
const email = location.state?.email;
const period = location.state?.period;
const date_period = location.state?.date_period;

if (!userid || !period || !date_period) {
    navigate("/");
    return null;
  }

  


  const handleActivateAccount = async () => {

    if (!userid) {
      toast.error("No userid found");
      return;
    }

    setIsUpdating(true);

    try {

      const res = await axios.post(
        `${API_URL}/activate-my-account-api`,
        { userid },
        { withCredentials: true }
      );

      if (res.data.success) {
        toast.success(res.data.message || "Account activated successfully.");
        setTimeout(() => {
          navigate("/");
        }, 1500);
      }

    } catch (err) {
      toast.error(err.response?.data?.error || "Something went wrong.");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="bg_med_green text-white min-vh-100 d-flex align-items-center justify-content-center">
      <ToastContainer />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-6">
            <div className=" text-white  ">
              <div className="  text-center">
                 

                  {/* Header (same gradient as Register) */}
                                 <div
                                   className="text-white rounded"
                                   style={{
                                     background: 'linear-gradient(135deg, #065c0cff, #088e3eff)',
                                     padding: '20px',
                                     textAlign: 'center'
                                   }}
                                 >
                                   <img src="img/logo_1.png" alt="Logo" height="50" className="mb-2" />
                                   <h4 className="fw-bold mb-1">Activate</h4>
                                   <small style={{ opacity: 0.9 }}>Your account is currently deactivated.</small>
                                 </div>
                 
                 
                                 {userid && period && date_period && (
                                 <p className="text-center  mt-4" style={{color: '#184a2c'}}>
                                     Duration: <strong>{period}</strong> <br />
                                     Activated date: <strong>{date_period}</strong>
                                 </p>
                                 )}
                                                         
                 
                                 <button className='btn btn-primary'
                                      onClick={handleActivateAccount}
                                      disabled={isUpdating}
                                 >
                                     {isUpdating ? "Activating..." : "Activate Now"}
                                 </button>
                 
                 
                                 <div
                                   className="text-white rounded mt-3"
                                   style={{
                                     background: 'linear-gradient(135deg, #065c0cff, #088e3eff)',
                                     padding: '10px',
                                     textAlign: 'center'
                                   }}
                                 >
                 
                                     <p className="text-center text-white" >
                                         Already active?
                                     <Link to="/login" className="fw-bold" style={{ color: '#184a2c', textDecoration: 'none' }}  > Login</Link>
                                     </p>
                 
                                 </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeactivatedAccount;
